export const ZONES = [
    ['recovery', 'Восстановление'],
    ['endurance', 'Аэробная'],
    ['tempo', 'Темп'],
    ['sweet_spot', 'Sweet Spot'],
    ['threshold', 'Порог'],
    ['vo2max', 'VO2max'],
    ['anaerobic', 'Анаэробная'],
]

export const ZONE_LABELS = Object.fromEntries(ZONES)

export const FAVORITES_KEY = 'trainer/workoutFavorites'

const DURATION_OPTIONS = [
    { value: 'lt30', label: 'до 30 мин' },
    { value: '30to60', label: '30–60 мин' },
    { value: 'gt60', label: 'более 60 мин' },
]

export function matchSearch(workout, searchText) {
    const q = (searchText || '').trim().toLowerCase()
    if (!q) return true
    return (workout.name || '').toLowerCase().includes(q)
        || (workout.author || '').toLowerCase().includes(q)
}

export function zoneSecondsOrZero(workout, key) {
    const p = (workout.properties || []).find(x => x.name === `time_in_zone: ${key}`)
    return (p && typeof p.val_int === 'number' && p.val_int > 0) ? p.val_int : 0
}

export function workoutTotalSeconds(workout) {
    const points = workout.points || []
    if (!points.length) return 0
    return Math.max(...points.map(p => p.t), 0)
}

export function durationBucket(seconds) {
    if (seconds < 1800) return 'lt30'
    if (seconds <= 3600) return '30to60'
    return 'gt60'
}

export function durationBucketLabel(seconds) {
    const opt = DURATION_OPTIONS.find(o => o.value === durationBucket(seconds))
    return opt ? opt.label : ''
}

export function filterWorkouts(workouts, opts = {}) {
    const {
        searchText,
        tab,
        durationFilter,
        zoneFilter = [],
        zoneMatch = 'all',
        minimumShare = 0,
        favoriteIds = [],
    } = opts
    const minShare = (Number(minimumShare) || 0) / 100

    return (workouts || []).filter(w => {
        if (!matchSearch(w, searchText)) return false
        if (tab === 'favorites' && !favoriteIds.includes(w.id)) return false
        if (tab === 'mine' && !w.is_mine) return false
        if (durationFilter) {
            if (durationBucket(workoutTotalSeconds(w)) !== durationFilter) return false
        }
        if (zoneFilter && zoneFilter.length) {
            const total = Math.max(1, workoutTotalSeconds(w))
            const shares = zoneFilter.map(z => zoneSecondsOrZero(w, z) / total)
            if (zoneMatch === 'any') {
                if (!shares.some(s => s >= minShare)) return false
            } else if (!shares.every(s => s >= minShare)) {
                return false
            }
        }
        return true
    })
}

export function sortWorkouts(workouts, opts = {}) {
    const { sortKey, zoneKey } = opts
    const arr = [...(workouts || [])]
    switch (sortKey) {
        case 'name':
            arr.sort((a, b) => (a.name || '').localeCompare(b.name || ''))
            break
        case 'author':
            arr.sort((a, b) => (a.author || '').localeCompare(b.author || ''))
            break
        case 'duration':
            arr.sort((a, b) => workoutTotalSeconds(a) - workoutTotalSeconds(b))
            break
        case 'zone':
            if (zoneKey) {
                arr.sort((a, b) => zoneSecondsOrZero(b, zoneKey) - zoneSecondsOrZero(a, zoneKey))
            }
            break
        default:
            break
    }
    return arr
}

export function formatZoneSummary(workout) {
    const total = Math.max(1, workoutTotalSeconds(workout))
    const parts = ZONES
        .map(([key]) => ({ key, share: zoneSecondsOrZero(workout, key) / total }))
        .filter(p => p.share > 0)
        .sort((a, b) => b.share - a.share)
        .slice(0, 2)
    if (!parts.length) return 'Зон нет'
    return parts.map(p => `${ZONE_LABELS[p.key]} ${Math.round(p.share * 100)}%`).join(' · ')
}

export function toggleFavoriteIds(ids, id) {
    return ids.includes(id) ? ids.filter(x => x !== id) : [...ids, id]
}

export function expandWorkoutPoints(points, ftp) {
    return (points || []).map(p => ({ t: p.t, v: Math.round((p.v || 0) * ftp / 100) }))
}

export function formatDuration(totalSeconds) {
    const t = Math.max(0, Math.round(totalSeconds || 0))
    const h = Math.floor(t / 3600)
    const m = Math.floor((t % 3600) / 60)
    const s = t % 60
    const mm = String(m).padStart(2, '0')
    const ss = String(s).padStart(2, '0')
    if (h > 0) return `${h}:${mm}:${ss}`
    return `${mm}:${ss}`
}
